export default __webpack_public_path__ + "static/media/paypal.3536bc34.svg";